// extracted by mini-css-extract-plugin
export default {"closePop":"closePop_closePop__VagNQ","btnWrpper":"closePop_btnWrpper__e6WvG"};